import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {pageSize} from '/constant/data.constant';
import {
  PAGE_NUMBER_FIELD_NAME,
  PAGE_SIZE_FIELD_NAME,
} from '/enum/apiFields.enum';
import {CLIENT_NOTES_STATE_IS_LOADING} from '/enum/clients.enum';
import {
  fetchMwlhr,
  getAlerts,
  getOrders,
  getProfile,
  setClientNotesState,
  updateClientNotes,
} from '/redux/action/client.action';
import {
  activatedOnById,
  coachIdById,
  firstOrderId,
  fullNameById,
  hasOrdersById,
  hasProfileById,
  mwlData,
  ordersSortParams,
} from '/redux/selector/client.selector';
import {coachFullNameById} from '/redux/selector/client.selector';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {fromProps, withProps} from '/util/selector.util';

import ClientProfile from './ClientProfile';
const withClientId = withProps({
  clientId: fromProps(get('recordId')),
});

export default connect(
  createStructuredSelector({
    userId,
    hasProfile: withClientId(hasProfileById),
    hasOrders: withClientId(hasOrdersById),
    ordersSorts: withClientId(ordersSortParams),
    coachId: withClientId(coachIdById),
    fullName: withClientId(fullNameById),
    coachName: withClientId(coachFullNameById),
    firstOrderId: withClientId(firstOrderId),
    mwlData: withClientId(mwlData),
    featureFlag: variablesFeatureFlag,
    activationDate: withClientId(activatedOnById),
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestAchievedRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
  }),
  dispatch => ({
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    getProfile: ({clientId}: any) => dispatch(getProfile({clientId})),
    getOrders: ({clientId, orderParams, appendData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(getOrders({clientId, orderParams, appendData})),
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    fetchMwlhr: ({clientId}: any) => dispatch(fetchMwlhr({clientId})),
    // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
    getAlerts: ({clientId}: any) => dispatch(getAlerts({clientId})),
    updateClientNotes: ({clientId, body}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(updateClientNotes({clientId, body})),

    setClientNotesState: ({clientId, stateName, stateValue}: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        setClientNotesState({
          clientId,
          stateName,
          stateValue,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const {hasProfile, hasOrders, ordersSorts} = stateProps;
    const {recordId: clientId} = ownProps;
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      hasData: hasProfile && hasOrders,
      fetchData: () => {
        return (
          Promise.resolve()
            // @ts-expect-error TS(2345): Argument of type '() => Action<any> | Promise<void... Remove this comment to see the full error message
            .then(() =>
              hasProfile
                ? Promise.resolve()
                : dispatchProps.getProfile({clientId}),
            )
            // @ts-expect-error TS(2345): Argument of type '() => Action<any> | Promise<void... Remove this comment to see the full error message
            .then(() =>
              hasOrders
                ? Promise.resolve()
                : dispatchProps.getOrders({
                    clientId,
                    orderParams: {
                      ...ordersSorts,
                      [PAGE_NUMBER_FIELD_NAME]: 1,
                      [PAGE_SIZE_FIELD_NAME]: pageSize,
                    },
                    appendData: false,
                  }),
            )
        );
      },
      getAlerts: () => {
        return dispatchProps.getAlerts({clientId});
      },
      updateNotes: ({body}: any) => {
        return dispatchProps.updateClientNotes({clientId, body});
      },
      fetchMwlhr: () => {
        return dispatchProps.fetchMwlhr({clientId});
      },
      setClientNotesState: () => {
        return dispatchProps.setClientNotesState({
          clientId,
          stateName: CLIENT_NOTES_STATE_IS_LOADING,
          stateValue: true,
        });
      },
    };
  },
)(ClientProfile);
